// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3YSEG","modalFooterButton":"ModalNotes_modalFooterButton__6jwB4"};